import type { FormInputType } from '@/components/UI/Form/types'

export default function getExcusedAbsenceFormInputs({
  sessions,
  preSelectedSessionId,
}: {
  sessions: { id: number; label: string }[]
  preSelectedSessionId?: number
}): FormInputType[] {
  const formInputs: FormInputType[] = [
    {
      label: 'Which required session are you unable to attend?',
      type: 'select',
      name: 'session_id',
      placeholder: 'Select an option',
      options: sessions.map(session => ({
        value: `${session.id}`,
        label: session.label,
      })),
      initialValue: preSelectedSessionId != null ? `${preSelectedSessionId}` : null,
      required: true,
      size: 6,
    },
    {
      label: 'Please share your reason for this absence',
      type: 'textarea',
      name: 'reason_explain',
      sublabel: 'This reason will be shared with the tutor.',
      required: true,
      size: 6,
    },
  ]

  return formInputs
}
